import {

    ApproverPolicy,
    IWorkflowProcessor,
    IWorkflowProcessorExtension,
    IWorkflowValidateOptions,
    IWorkflowValidateTransitionOptions
} from "../PA.Core/PA.Core.IF.Workflow";
import {ASync} from "../PA.Core/Basic/ASync";
import {WB_UserRow} from "../PA.Core/PAdbSchemaRows";
import {WorkflowProcessor} from "../PA.Core/Workflow/WorkflowProcessor";
import {UserSecurityService} from "../PA.Security.Services/UserSecurityService";
import * as _ from 'lodash'
import {esWB_User} from "../PA.Core/PAdbSchema";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {IUsrContext} from "../PA.Core/PA.Core.IF.User";
import {WarningMessage_restate} from "../PA.Core/Basic/MessageUtils";
import {PaymentBO} from "./PaymentBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";


export class PaymentBOStandardWorkflowExtension
    implements
        IWorkflowProcessorExtension
{

    paymentBO: PaymentBO
    userCtx: IUsrContext

    constructor(aPaymentBO: PaymentBO){
        this.paymentBO = aPaymentBO
        this.userCtx  = PAEnvironment.getValue(PAEnvironment.UserContext)

    }

    get id(): string{
        return "PaymentBOStandardWorkflowExtension"
    }

    OnLoad(aWfProcessor: IWorkflowProcessor): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            console.log(self.id, ": OnLoad")
            aWfProcessor.setPolicyFields({WorkflowVisible: true, CurrentStateVisible: true, NextStateVisible: true, NextStateEditable: true})
            resolve()
        })
    }


    GetApproverPolicy(aWfProcessor: IWorkflowProcessor): Promise<ApproverPolicy> {
        return ASync.resolve(ApproverPolicy.ApproverList)
    }

    LogTransitionCondition(aWfProcessor: IWorkflowProcessor): boolean {
        const self = this

        // Always log when server side..
        if(PAEnvironment.isNode())
            return true;

        return true;
    }

    async GetApproverList(aWfProcessor: IWorkflowProcessor): Promise<WB_UserRow[]> {
        let aWp: WorkflowProcessor = <WorkflowProcessor>aWfProcessor
        const self = this

        let wbCustId = self.paymentBO.WB_Payment.cif.WB_CUST_ID_FUNDING || self.paymentBO.WB_Payment.cif.WB_CUST_ID_PLANNING
        let wbPeriodId = 0
        return []
        /*
        let usersIds = await UserSecurityService.getResponsibleUserList(wbCustId, wbPeriodId, [], [], 0)

        if (_.isEmpty(usersIds))
            return []

        let userRecs: WB_UserRow[] = <any>(await aWfProcessor.dbContext.findUsingCache(esWB_User, usersIds))

        return userRecs
         */
    }

    async Validate(aWfProcessor: IWorkflowProcessor, options?: IWorkflowValidateTransitionOptions): Promise<void> {
        const self = this
        const opts: IWorkflowValidateTransitionOptions = options || {}

        await self._validate(aWfProcessor, opts)
    }

    //<editor-fold desc="Validate Functions">

    private _validate(aWfProcessor: IWorkflowProcessor, options?: IWorkflowValidateTransitionOptions): Promise<void> {
        const self = this
        const opts = options || {}

        return new Promise<void>((resolve, error) => {

            //  Validate only State Transitions
            let NextState = aWfProcessor.NextState

            // Check if Next State is overriden.
            if(opts.UsingNextState){
                NextState = opts.UsingNextState
            } else if (opts.UsingNextStateType){
                let optsState = aWfProcessor.getStateType(opts.UsingNextStateType)
                if(_.isArray(optsState)){ optsState = _.first(optsState)}
                if(optsState){
                    NextState =optsState
                }
            }
            if(_.isUndefined(NextState) || _.isEmpty(NextState)){
              self.paymentBO.ValidateMessageProvider.addMessage({
                    code: 'inaccurateWorkflow',
                    type: MessageType.Error,
                    title: "Workflow didn't have Next Status available, please check Workflow configuration for Payment Type!",
                    description: "",
                    subtitle: "",
                    count: 0})
                self.paymentBO.SaveProgressProvider.finish();
                resolve()
                return
            }
            let NextStateId = NextState.cif.WB_STATUS_ID

            if(aWfProcessor.CurrentStateId == NextStateId){
                resolve()
                return
            }

            let validateFunction: (a: IWorkflowProcessor)=> Promise<void> = undefined

            switch (true) {
                case NextState.StatusTypeInitial:
                case NextState.StatusTypeRejected:
                case NextState.StatusTypeRevisionDenied:
                    // No Validation
                    break;

                case NextState.StatusTypeApproved:
                    // Add Validation Function
                    validateFunction = self._validateStateTransition_Approved.bind(self);
                    break;

                case NextState.StatusTypeCancelled:
                    validateFunction = self._validateStateTransition_Cancel.bind(self);
                    break;

            }

            if(!_.isFunction(validateFunction)){
                resolve()
                return
            }

            validateFunction(aWfProcessor)
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })

        })
    }

    private async _validateStateTransition_Approved(aWfProcessor: IWorkflowProcessor): Promise<void> {
        const self = this

        let bo = self.paymentBO
        let pmt = bo.WB_Payment

        let arrApprovalWarningMessageTexts: string[] = []

        if (arrApprovalWarningMessageTexts.length) {
            let sMsg = arrApprovalWarningMessageTexts.join("\n")
            WarningMessage_restate(bo.ValidateMessageProvider, true, "ApprovalWarnings", {
                Title: "Approval Warnings",
                Desc: sMsg
            })
        }



    }

    private async _validateStateTransition_Cancel(aWfProcessor: IWorkflowProcessor): Promise<void> {
        const self = this

    }

    //</editor-fold>


    OnValidatationSucess(aWfProcessor: IWorkflowProcessor, options?: IWorkflowValidateOptions): Promise<void> {
        const self = this
        const opts = options || {}

        return new Promise<void>((resolve, error) => {

            let NextState = aWfProcessor.NextState
            let NextStateId = NextState.cif.WB_STATUS_ID

            let onValidateSuccessFunction: (a: IWorkflowProcessor)=> Promise<void> = undefined

            switch (true) {
                case NextState.StatusTypeInitial:
                case NextState.StatusTypeRejected:
                    // No Function
                    break;

                case NextState.StatusTypeApproved:
                    // Add Validation Function
                    onValidateSuccessFunction = self._onValidateSuccess_Approved.bind(self);
                    break;

                case NextState.StatusTypeCancelled:
                    onValidateSuccessFunction = self._onValidateSuccess_Cancel.bind(self);
                    break;

                case NextState.StatusTypeClosed:
                    onValidateSuccessFunction = self._onValidateSuccess_Closed.bind(self)
                    break;
            }

            if(!_.isFunction(onValidateSuccessFunction)){
                resolve()
                return
            }

            onValidateSuccessFunction(aWfProcessor)
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    //<editor-fold desc="OnValidate Success Functions">

    private async _onValidateSuccess_Approved(aWfProcessor: IWorkflowProcessor): Promise<void> {
        const self = this

        let bo = self.paymentBO
        let pmt = bo.WB_Payment


    }

    private async _onValidateSuccess_Closed(aWfProcessor: IWorkflowProcessor): Promise<void> {
        const self = this

    }

    private async _onValidateSuccess_Cancel(aWfProcessor: IWorkflowProcessor): Promise<void> {
        const self = this

    }
    //</editor-fold>


    async OnSaved(aWfProcessor: IWorkflowProcessor): Promise<void> {
        const self = this
        console.log(self.id, ": OnSaved")
    }

    async OnReloaded(aWfProcessor: IWorkflowProcessor): Promise<void> {
        const self = this
        console.log(self.id, ": OnReloaded")
    }


}
